//import Swiper from '../../node_modules/swiper/swiper-bundle.js';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// Configure Swiper sliders (https://swiperjs.com/swiper-api)

// Slider settings
const defaultSettings = {
  slidesPerView: 1,
  spaceBetween: 35,
  centerInsufficientSlides: true,
  watchOverflow: true,
  modules: [Navigation],
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpointsInverse: true,
  breakpoints: {
    480: {
      slidesPerView: 2
    },
    768: {
      slidesPerView: 3
    },
    1024: {
      slidesPerView: 5
    }
  }
};

const halfWidthBreakpoints = {
    480: {
      slidesPerView: 2
    },
    768: {
      slidesPerView: 3
    },
    1024: {
      slidesPerView: 2
    },
    1400: {
      slidesPerView: 3
    }
};

const halfWidthSettings = { ...defaultSettings };
halfWidthSettings.breakpoints = halfWidthBreakpoints;

// Initialize sliders
const swiper = new Swiper('.swiper', defaultSettings);

const swiperHalfWidth = new Swiper('.col-lg-6 .swiper-container', halfWidthSettings);
